import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useUpdateTransaction({ id } = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    date,
    vaultId,
    categoryId,
    description = '',
    amount,
    recurring_settings,
    modelId,
    update_all,
    is_skip_allocation,
  }) => {
    const response = await httpClient.put(
      `/team/cash-flow/transactions/${id}`,
      {
        transaction_date: date,
        vault_id: vaultId,
        transaction_category_id: categoryId,
        description,
        amount,
        recurring_settings,
        what_if_id: modelId,
        update_all,
        is_skip_allocation,
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({ queryKey: ['todos', 'list'] })
      queryClient.invalidateQueries({
        queryKey: ['transaction-repeat-options'],
      })
      queryClient.invalidateQueries({
        queryKey: ['models'],
      })

      toast.success('Transaction successfully updated.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
